var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
// TODO: Needs to be added as a background image
// import checkMark from "../assets/checkmark.svg";
var CustomInput = styled.input.attrs({ type: 'checkbox' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 16px;\n  width: 16px;\n  border: 1px solid ", ";\n  -webkit-appearance: none;\n  background-color: ", ";\n  margin-right: 20px;\n  &:checked {\n    background-color: ", ";\n    background-image: url();\n  }\n"], ["\n  height: 16px;\n  width: 16px;\n  border: 1px solid ", ";\n  -webkit-appearance: none;\n  background-color: ", ";\n  margin-right: 20px;\n  &:checked {\n    background-color: ", ";\n    background-image: url();\n  }\n"])), colors.TURQUOISE, colors.WHITE, colors.BLACK);
var CheckBox = function (props) {
    var checked = props.checked, onChange = props.onChange;
    return React.createElement(CustomInput, { checked: checked, onChange: onChange });
};
export default CheckBox;
var templateObject_1;
//# sourceMappingURL=BrandCheckBox.js.map